import React, { createContext } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";
import useRTickets from "../../hooks/useRTickets";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
	const { loading, whatsApps } = useWhatsApps();
	const rtickets = useRTickets();

	return (
		<WhatsAppsContext.Provider value={{ whatsApps, loading, rtickets }}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
